import {createAction} from '@reduxjs/toolkit';

export const toggleCollectionVisibility = createAction(
  'collections/toggleVisible'
);

export const setCollectionVisibility = createAction('collections/setVisible');
